import {
    Field,
    FieldArray,
    FieldInputProps,
    Form,
    Formik as FormikBase,
    FormikConfig,
    FormikErrors,
    FormikHandlers,
    FormikHelpers,
    FormikProps,
    FormikTouched,
    FormikValues,
    getIn,
    useField,
    useFormik,
    useFormikContext,
} from 'formik'
import { withFormikDevtools } from 'formik-devtools-extension'
import { ReactElement } from 'react'

type CustomFormikProps<T> = {
    children: (props: FormikProps<T>) => ReactElement
} & Omit<FormikConfig<T>, 'children'>

const CustomFormikChildren = <T,>({
    children,
    ...props
}: FormikProps<T> & {
    children: (props: FormikProps<T>) => ReactElement
}) => {
    return children(props)
}

const Formik = <T extends FormikValues>({ children, ...props }: CustomFormikProps<T>): ReactElement => {
    const showFormikDevTools = process.env.STAGE === 'localhost'
    return (
        <FormikBase<T> {...props}>
            {(formikProps) => {
                if (showFormikDevTools) {
                    withFormikDevtools(formikProps)
                }

                return <CustomFormikChildren {...formikProps}>{children}</CustomFormikChildren>
            }}
        </FormikBase>
    )
}

export { Formik, Form, useFormikContext, useField, Field, FieldArray, getIn, useFormik }
export type { FormikErrors, FormikHandlers, FormikHelpers, FormikTouched, FieldInputProps, FormikProps, FormikConfig }
